<template>
  <!--begin::List Widget 4-->
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0">
      <h3 class="card-title font-weight-bolder text-dark">{{ $t('dashboard.top_operators')}}</h3>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-2">
      <template v-for="(item, i) in list">
        <!--begin::Item-->
        <div class="d-flex align-items-center mb-2" v-bind:key="i">
          <!--begin::Symbol-->
          <div class="btn btn-success btn-icon mr-5 pb-0">
            <span class="symbol-label">
              <img :src="item.svg" width="26" height="26">
            </span>
          </div>
          <!--end::Symbol-->
          <!--begin::Text-->
          <div class="d-flex flex-column mr-auto">
            <a class="text-dark text-hover-primary mb-0 h6 font-weight-bolder">
              {{ item.title }}
            </a>
            <span class="text-muted opacity-50 font-weight-bold">
              {{ item.desc }}
            </span>
          </div>
          <!--end::Text-->
          <!--begin::Dropdown-->
          <Dropdown2><i class="ki ki-bold-more-hor"></i></Dropdown2>
          <!--end::Dropdown-->
        </div>
        <!--end::Item-->
      </template>
    </div>
    <!--end::Body-->
  </div>
  <!--end: List Widget 4-->
</template>

<script>
import Dropdown2 from "@/view/content/dropdown/Dropdown2.vue";
import Dropdown4 from "@/view/content/dropdown/Dropdown4.vue";
import { mapGetters } from "vuex";

export default {
  name: "widget-3",
  data() {
    return {
      list: [
        {
          title: "Ali ATEŞ",
          desc: "Operator Teknisyeni",
          svg: "media/svg/avatars/015-boy-6.svg",
          style: "svg-icon-primary"
        },
        {
          title: "Ayşen SÖNMEZ",
          desc: "Operator Teknisyeni",
          svg: "media/svg/avatars/006-girl-3.svg",
          style: "svg-icon-warning"
        },
        {
          title: "Naci FIRTINA",
          desc: "Operator Teknisyeni",
          style: "svg-icon-success",
          svg: "media/svg/avatars/016-boy-7.svg",
        },
        {
          title: "Ferhat ELİBOL",
          desc: "Operator Teknisyeni",
          svg: "media/svg/avatars/009-boy-4.svg",
          style: "svg-icon-danger"
        },
        {
          title: "Faruk IŞIK",
          desc: "Operator Teknisyeni",
          svg: "media/svg/avatars/011-boy-5.svg",
          style: "svg-icon-info"
        }
      ]
    };
  },
  components: {
    Dropdown2,
    Dropdown4
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  }
};
</script>
